import register from "./asset-register.json";

const MAP = Object.fromEntries(register.images.map((i) => [i.id, i]));

/**
 * Look up a registered image by id. Throws in development if the id is
 * unknown so wrong images can never slip in. Returns a stable object
 * with `src`, `alt`, `subject`, `mobileSrc`.
 */
export function getImage(id) {
  const entry = MAP[id];
  if (!entry) {
    const msg = `[asset-register] unknown image id: '${id}'. Add it to /app/frontend/src/assets/asset-register.json first.`;
    if (process.env.NODE_ENV !== "production") {
      throw new Error(msg);
    }
    // In production, don't crash the page — return a transparent placeholder.
    return { src: "", alt: "", subject: "", mobileSrc: "" };
  }
  return {
    src: entry.desktop_path,
    mobileSrc: entry.mobile_path || entry.desktop_path,
    alt: entry.alt_text,
    subject: entry.actual_subject,
  };
}

/**
 * <Img id="..." /> — the ONLY sanctioned way to render photography on
 * the public site. Bypassing it (e.g. a bare <img src="..." />) will slip
 * past code review; keep this the default.
 */
export function Img({ id, className, style, loading = "lazy", ...rest }) {
  const { src, alt } = getImage(id);
  if (!src) return null;
  return (
    <img src={src} alt={alt} className={className} style={style} loading={loading} {...rest} />
  );
}

export { register };
